import React from "react";
import CRUDAdmin from "../../components/admin/CRUDAdmin";

export default function Testimonials() {
  return (
    <CRUDAdmin
      title="Testimonials"
      subtitle="Patron reviews shown on the website."
      endpoint="/admin/testimonials"
      testIdPrefix="tes"
      defaults={{ active: true, order: 100, rating: 5 }}
      columns={[
        { title: "Patron", render: r => <><div className="serif text-lg">{r.name}</div><div className="text-navy-900/50 text-xs">{r.event}</div></> },
        { title: "Rating", render: r => "★".repeat(r.rating || 5) },
        { title: "Order", key: "order" },
      ]}
      fields={[
        { name: "name", label: "Patron Name" },
        { name: "event", label: "Event" },
        { name: "rating", label: "Rating (1-5)", type: "number" },
        { name: "order", label: "Order", type: "number" },
        { name: "quote", label: "Testimonial", type: "textarea", full: true },
        { name: "image", label: "Photo", type: "media", full: true },
        { name: "active", label: "Active", type: "checkbox" },
      ]}
    />
  );
}
